import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useCallback, useRef, useState } from 'react';
export default function useStateRef(initialState) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var ref = useRef();
  var setValue = useCallback(function (nextValue) {
    if (typeof nextValue === 'function') {
      setValue(function (state) {
        nextValue = nextValue(state);
        ref.current = nextValue;
        return nextValue;
      });
    } else {
      ref.current = nextValue;
      setValue(nextValue);
    }
  }, [ref]);
  ref.current = state;
  return [state, setState, ref];
}